@import "../../variables.scss";

.cvpopup {
  border: 1px rgb(82, 82, 82) dashed;
  border-radius: 4px;
  cursor: default;
  height: 400px;
  width: 700px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__button {
    box-shadow: none !important;
    &:hover {
      background-color: #2196f3 !important;
    }
  }
  &__cancel {
    box-shadow: none !important;
    &:hover:not([disabled]) {
      color: white !important;
    }
  }
  &__exit {
    position: absolute;
    right: 1rem;
    top: 1rem;
    font-size: 47px;
  }
  &__picked {
    background: #eaeaea;
  }
  &__progress {
    appearance: none;
    width: 560px;
    height: 10px;
    &::-webkit-progress-value {
      background-color: $color-orange;
      border-radius: 5px;
    }
    &::-webkit-progress-bar {
      background-color: white;
      border-radius: 5px;
    }
  }
  &:hover {
    border: 1px black dashed;
    background: #eaeaea;
  }
  &__wrapper {
    width: 732px;
    height: 95vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    @media (max-width: $size-md) {
      width: 100%;
    }
    @media (min-height: 600px) {
      height: 90vh;
    }
    @media (min-height: 793px) {
      height: 100%;
    }
  }
  &__dropzone {
    &_title {
      font-weight: 300;
      font-size: 24px;
      line-height: 24px;
    }
    &_subtitle {
      font-size: 12px;
      letter-spacing: 0.3px;
    }
    &_line {
      border-top: 1px #bababa solid;
      width: 300px;
      display: block;
      height: 1px;
    }
  }
}
